module.exports = __webpack_public_path__ + "images/stickers/pete-space@2x.aa9cb8354739fb355a4a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-space@2x.png
// module id = 7d5f
// module chunks = 0